var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPicture = function SvgPicture(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1005544_cc",
    transform: "translate(0 -12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M21.207,12.5H2.892A2.9,2.9,0,0,0,0,15.392V27.052a2.9,2.9,0,0,0,2.892,2.89H4.936v-1.68H2.892a1.207,1.207,0,0,1-1.212-1.21V15.392a1.207,1.207,0,0,1,1.2-1.2H21.207a1.207,1.207,0,0,1,1.2,1.2v1.54h1.68v-1.54A2.9,2.9,0,0,0,21.207,12.5Z",
    fill: "#d1cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M39.479,31.23H21.164a1.207,1.207,0,0,0-1.2,1.2V44.093a1.207,1.207,0,0,0,1.2,1.2H39.479a1.207,1.207,0,0,0,1.2-1.2V32.434a1.207,1.207,0,0,0-1.2-1.2Zm-5.04,1.576a1.6,1.6,0,1,1-1.144.463A1.613,1.613,0,0,1,34.439,32.806Zm3.36,10.9H22.668c-.736-.031-1.016-.5-.686-1.1.031-.056.067-.112.1-.165l4.906-7.756c.538-.84,1.12-.84,1.66,0L32.5,40.764c.053.084.112.165.185.28l.168-.255q.743-1.18,1.492-2.358a2.262,2.262,0,0,1,.325-.423.714.714,0,0,1,1.047,0,1.641,1.641,0,0,1,.241.308q1.316,2.072,2.624,4.15c.476.759.179,1.229-.778,1.243Z",
    transform: "translate(-14.371 -13.486)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M40.8,45.574a1.641,1.641,0,0,0-.241-.308.714.714,0,0,0-1.047,0,2.262,2.262,0,0,0-.325.423c-.5.784-.994,1.571-1.492,2.358l-.168.255c-.07-.1-.132-.185-.185-.28L33.5,41.94c-.538-.84-1.12-.84-1.66,0L26.928,49.7c-.034.056-.07.109-.1.165-.33.6-.05,1.072.686,1.092,1.014.025,2.03,0,3.044,0H42.644c.958,0,1.254-.484.776-1.243Q42.115,47.644,40.8,45.574Z",
    transform: "translate(-19.216 -20.743)",
    fill: "#d1cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M67.486,40.086a1.607,1.607,0,1,0-1.135-.481,1.613,1.613,0,0,0,1.135.481Z",
    transform: "translate(-47.441 -17.539)",
    fill: "#d1cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M35.137,25.21H16.822A2.9,2.9,0,0,0,13.93,28.1V39.759a2.9,2.9,0,0,0,2.892,2.892H35.137a2.9,2.9,0,0,0,2.892-2.892V28.1A2.9,2.9,0,0,0,35.137,25.21Zm1.2,14.56a1.207,1.207,0,0,1-1.2,1.2H16.822a1.207,1.207,0,0,1-1.2-1.2V28.1a1.207,1.207,0,0,1,1.2-1.2H35.137a1.207,1.207,0,0,1,1.2,1.2V39.759Z",
    transform: "translate(-10.03 -9.151)",
    fill: "#d1cece"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picture.5704f4da.svg";
export { ForwardRef as ReactComponent };